import { render, staticRenderFns } from "./NewDialog.vue?vue&type=template&id=5ad721e8"
import script from "./NewDialog.vue?vue&type=script&lang=js"
export * from "./NewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports